import searchIcon from '@jetbrains/icons/search.svg'
import Input, {Size as InputSize} from '@jetbrains/ring-ui/components/input/input'
import {memo, useRef, useEffect, useCallback} from 'react'

import useSearchInput from '../../../../../../hooks/useSearchInput'

import styles from './TestsSearch.css'

type Props = {
  value: string
  onChange: (value: string) => unknown
}

const TIMEOUT_MS = 500

function TestsSearch({value: externalValue, onChange: externalOnChange}: Props) {
  const changeTextTimeoutRef = useRef<number>()
  useEffect(() => clearTimeout(changeTextTimeoutRef.current), [])

  const onChange = useCallback(
    (value: string) => {
      clearTimeout(changeTextTimeoutRef.current)
      changeTextTimeoutRef.current = window.setTimeout(() => externalOnChange(value), TIMEOUT_MS)
    },
    [externalOnChange],
  )

  const searchInput = useSearchInput(externalValue, onChange)
  return (
    <Input
      data-test-build-tests="filter-input"
      inputRef={searchInput.inputRef}
      type="search"
      size={InputSize.L}
      placeholder={`Search`}
      className={styles.inputContainer}
      icon={searchIcon}
      autoComplete={externalValue === searchInput.value ? 'off' : 'on'}
      value={searchInput.value}
      onChange={searchInput.onChange}
      onClear={searchInput.onClear}
    />
  )
}

export default memo<Props>(TestsSearch)
